import { api } from './api';

export interface MapMarker {
  id: string;
  type: 'company' | 'individual';
  displayName: string;
  status: 'cold' | 'warm' | 'client';
  latitude: number;
  longitude: number;
  addressStreet: string | null;
  addressCity: string | null;
  addressPostalCode: string | null;
  potential: 'low' | 'medium' | 'high' | 'very_high' | null;
  assignedUserId: string;
  assignedUser: { id: string; firstName: string; lastName: string };
  opportunitiesCount: number;
}

export interface MapResponse {
  markers: MapMarker[];
  totalCount: number;
  truncated: boolean;
  /** Centroid géocodé (filtre rayon) - permet de centrer/zoomer la carte
   *  sur la zone de recherche. `null` quand pas de filtre rayon. */
  geocodedCenter: { latitude: number; longitude: number } | null;
}

/**
 * Filtres MapPage. Multi-select étendu 2026-04-27 (UI multi-dropdowns) :
 * `status`, `potential`, `team_id`, `contract_type_id` deviennent des
 * arrays. Backend les accepte en CSV (cf prospects.schemas.ts mapQuery).
 *
 * Filtre rayon géographique : `near_location` (ville ou CP) + `radius_km`.
 * Couple indissociable côté UI (vidé l'un vide l'autre pour éviter le 422
 * du refine Zod).
 */
export interface MapFilters {
  status?: Array<'cold' | 'warm' | 'client'>;
  type?: 'company' | 'individual';
  assigned_user_id?: string;
  team_id?: string[];
  contract_type_id?: string[];
  tag?: string;
  potential?: Array<'low' | 'medium' | 'high' | 'very_high'>;
  near_location?: string;
  radius_km?: number;
}

function toQuery(filters: MapFilters): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    if (Array.isArray(v)) {
      if (v.length === 0) continue;
      params.set(k, v.join(','));
    } else {
      params.set(k, String(v));
    }
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const mapApi = {
  list: (token: string, filters: MapFilters = {}) =>
    api.get<MapResponse>(`/api/v1/prospects/map${toQuery(filters)}`, { accessToken: token }),
};
